import React, { useContext, useEffect, useState } from "react";
import "../../../assests/css/studentdashboard/StudentLogin.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import ClipLoader from "react-spinners/ClipLoader";

const StudentLogin = () => {
  const [loginLoading, setLoginLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
const {
  baseUrl, authToken,setAuthToken, setLoggedInStudent} = useContext(AppContext);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [savedStudent, setSavedStudent] = useState(null);

const validateEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  const stdLogin = (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (!validateEmail(email)) {
      setErrorMessage("Please enter a valid email.");
      return;
    }
    if (!password) {
      setErrorMessage("Please enter your password.");
      return;
    }

    setLoginLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/student/auth/studentLogin`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success == true) {
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          setLoggedInStudent(response.data.student);
          // localStorage.setItem("studentEmail", email);
          // localStorage.setItem("studentPassword", password);
          localStorage.setItem("student", JSON.stringify(response.data.student));
          setEmail("");
          setPassword("");

          navigate("/student/dashboard");
        } else {
          setErrorMessage(response.data.message || "Please enter a valid email or password.");
        }
      })
      .catch((error) => {
        console.log(error);
        setErrorMessage(
          error.response?.data?.message || "Please enter a valid email or password."
        );
      })
      .finally(() => {
        setLoginLoading(false);
      });
  };
// const stdLoginAuto = (stdEmail, stdPassword) => {
//   setLoginLoading(true);

//   const formData = new FormData();
//   formData.append("email", stdEmail);
//   formData.append("password", stdPassword);

//   axios
//     .post(`${baseUrl}/student/auth/studentLogin`, formData, {
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     })
//     .then((response) => {
//       console.log("AUTO LOGIN RESPONSE:", response.data);

//       if (response.data.success === true) {

//         // Token save
//         localStorage.setItem("authToken", response.data.token);
//         setAuthToken(response.data.token);

//         // IMPORTANT: Student data save
//         localStorage.setItem(
//           "student",
//           JSON.stringify(response.data.student)
//         );

//         // Email/password ki zaroorat ab nahi
//         localStorage.removeItem("studentEmail");
//         localStorage.removeItem("studentPassword");

//         // Dashboard
//         navigate("/student/dashboard");
//       } else {
//         localStorage.removeItem("studentEmail");
//         localStorage.removeItem("studentPassword");

//         setErrorMessage(
//           response.data.message || "Auto login failed."
//         );
//       }
//     })
//     .catch((error) => {
//       console.log("AUTO LOGIN ERROR:", error);

//       localStorage.removeItem("studentEmail");
//       localStorage.removeItem("studentPassword");

//       setErrorMessage(
//         error.response?.data?.message ||
//         "Auto login failed. Please login manually."
//       );
//     })
   
// };

  // const continueStudent = () => {
  //   const savedToken = localStorage.getItem("authToken");
  //   const savedStudent = localStorage.getItem("student");

  //   if (savedToken && savedStudent) {
  //     setAuthToken(savedToken);
  //     navigate("/student/dashboard");
  //   }
  // };


  // const stdLoginAuto = (stdEmail, stdPassword) => {
  //   setLoginLoading(true);
  //   console.log("Login function called", email, password);
  //   // e.preventDefault();
  //   const formData = new FormData();
  //   formData.append("email", stdEmail);
  //   formData.append("password", stdPassword);
  //   axios
  //     .post(`${baseUrl}/student/auth/studentLogin`, formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     })
  //     .then((response) => {
  //       console.log(response.data);
  //       if (response.data.success == true) {
  //         localStorage.setItem("authToken", response.data.token); //global available hota ha
  //         setAuthToken(response.data.token);
  //         setLoginLoading(false);
  //         setEmail("");
  //         setPassword("");
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setLoginLoading(false);
  //     });
  // };

  // useEffect(() => {
  //   const storedToken = localStorage.getItem("authToken");
  //   if (storedToken) {
  //     if (!authToken) setAuthToken(storedToken);
  //     navigate("/student/dashboard");
  //     return;
  //   }

  //   const stdEmail = localStorage.getItem("studentEmail");
  //   const stdPassword = localStorage.getItem("studentPassword");
  //   if (stdEmail && stdPassword) {
  //     stdLoginAuto(stdEmail, stdPassword);
  //   } else {
  //     setLoginLoading(false);
  //   }
  // }, []);
useEffect(() => {
  setLoginLoading(false);
}, []);

  return (
    <>
      {loginLoading ? (
        <div className="spinner-class">
          <ClipLoader
            color="black"
            loading={loginLoading}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : (
        <div className="sl-container">
          <div className="sl-card">
            <div className="sl-header">
              <div className="sl-icon">🎓</div>
              <h2 className="sl-title">Student Login</h2>
              <p className="sl-subtitle">Login to your student account</p>
            </div>

            {errorMessage && (
              <p className="sl-error" style={{ color: "red" }}>
                {errorMessage}
              </p>
            )}

            <form className="sl-form" onSubmit={stdLogin}>
              <div className="sl-field">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                />
              </div>

              <div className="sl-field">
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
              </div>

              <a
                href="/forgot-password"
                className="forgot-link d-block text-center mt-4"
              >
                Forgot your password?
              </a>

              <button className="sl-btn" type="submit" disabled={loginLoading}>
                {loginLoading ? "LOGGING IN..." : "LOGIN"}
              </button>

              <p className="sl-register-text">
                Don't have an account?{" "}
               <a
                href="/student-register"
                className="register-link"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/student-register");
                }}
                >
                Register
              </a>
            </p>
          </form>
        </div>
        </div >
      )}
    </>
  );
};

export default StudentLogin;